import { apiClient } from './client'
import type { MeasurementUnit } from '../measurements'

export type DashboardUserRole = 'Admin' | 'Editor' | 'Guest' | 'TourAdmin' | 'SupportAgent' | 'SupportAdmin'

export type AuthUser = {
  id: string
  email: string
  displayName?: string | null
  role?: DashboardUserRole | number
  operatorId?: string | null
  measurementUnit?: MeasurementUnit
}

export type AuthResponse = {
  token: string
  refreshToken?: string
  user: AuthUser
}

export type LoginRequest = {
  email: string
  password: string
  rememberMe?: boolean
}

export type GoogleLoginRequest = {
  idToken: string
  rememberMe?: boolean
  password?: string
}

export type PasswordResetResponse = {
  message: string
}

export async function login(request: LoginRequest) {
  const { data } = await apiClient.post<AuthResponse>('/api/auth/login', request)
  return data
}

export async function loginWithGoogle(request: GoogleLoginRequest) {
  const { data } = await apiClient.post<AuthResponse>('/api/auth/google', request)
  return data
}

export async function requestPasswordReset(email: string) {
  const { data } = await apiClient.post<PasswordResetResponse>('/api/auth/forgot-password', { email })
  return data
}

export async function resetPassword(token: string, newPassword: string) {
  const { data } = await apiClient.post<PasswordResetResponse>('/api/auth/reset-password', { token, newPassword })
  return data
}

export async function getCurrentUser() {
  const { data } = await apiClient.get<AuthUser>('/api/admin/users/me')
  return data
}

export async function refreshToken(refreshToken: string) {
  const { data } = await apiClient.post<AuthResponse>('/api/auth/refresh', { refreshToken })
  return data
}

export async function logout(refreshToken?: string) {
  await apiClient.post('/api/auth/logout', { refreshToken })
}
